import { render, staticRenderFns } from "./AddVolunteer.vue?vue&type=template&id=4527daeb"
import script from "./AddVolunteer.vue?vue&type=script&lang=js"
export * from "./AddVolunteer.vue?vue&type=script&lang=js"
import style0 from "./AddVolunteer.vue?vue&type=style&index=0&id=4527daeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports